
export const processMailingAddressRule = section => {
  return {
    ...section,
    address: section.same_as_physical ? null : section.address,
    city: section.same_as_physical ? null : section.city,
    country_id: section.same_as_physical ? null : section.country_id,
    county: section.same_as_physical ? null : section.county,
    state: section.same_as_physical ? null : section.state,
    zip: section.same_as_physical ? null : section.zip,
  }
}

export const processPhysicalAddressRule = section => {
  return { ...section }
}

export const cleanAddress = address => {
  const localAddress = {
    ...address,
    address: null,
    city: null,
    country_id: null,
    county: null,
    end_date: null,
    end_date_format: null,
    end_date_uncertain: null,
    same_as_physical: false,
    start_date: null,
    start_date_format: null,
    start_date_uncertain: null,
    state: null,
    zip: null,
  }

  if (address.same_as_physical) localAddress.same_as_physical = true

  return localAddress
}

export const isAddressEmpty = address => {
  return !(address?.address || '').trim().length &&
    !(address?.city || '').trim().length &&
    !address?.country_id &&
    !(address?.county || '').trim().length &&
    !(address?.state || '').trim().length &&
    !(address?.zip || '').trim().length
}

export const convertAddressToHistory = address => {
  return {
    address: address.address,
    country_id: address.country_id,
    city: address.city,
    county: address.county,
    end_date: address.end_date,
    end_date_format: address.end_date_format,
    end_date_uncertain: address.end_date_uncertain,
    int_state: address.int_state,
    int_zip: address.int_zip,
    non_us_data: address.non_us_data,
    start_date: address.start_date,
    start_date_format: address.start_date_format,
    start_date_uncertain: address.start_date_uncertain,
    state: address.state,
    zip: address.zip,
  }
}
